module.exports = __webpack_public_path__ + "static/media/s_bar11.66859017.svg";